import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-yuan', 'CurrencyYuan', [["path",{"d":"M12 19v-7l-5 -7"}],["path",{"d":"M17 5l-5 7"}],["path",{"d":"M8 13h8"}]]);